/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 28/02/22
 */

import { BarChartData } from '@/wpt-lib/components/Charts/BarChart';
import { Labels } from '@/wpt-lib/components/contexts/LabelsContext/LabelsProvider';
import { WorkplanVersion } from '@/wpt-lib/interfaces/Workplan';
const getWorkloadChartData = (
    workplanVersion: WorkplanVersion,
    labels: Labels['ACTIVITY']['academicFocusArea'],
): BarChartData[] => {
    const teachingTarget = workplanVersion.teachingWorkloadPortion * 100;
    const researchTarget = workplanVersion.researchWorkloadPortion * 100;
    const serviceTarget = workplanVersion.serviceWorkloadPortion * 100;
    const seniorTarget = workplanVersion.seniorStaffWorkloadPortion * 100;
    const professionalTarget = workplanVersion.professionalStaffWorkloadPortion * 100;
    const colors = {
        red: '#CC1400',
        blue: '#0F4BEB',
        green: '#09D36A',
        orange: '#FF9B00',
        pink: '#FF4081',
    };

    const academicBarChartData = [
        {
            label: labels?.TEACHING ?? 'Teaching and Educational Facilitation',
            colourTheme: colors.red,
            amount: teachingTarget,
            target: teachingTarget,
        },
        {
            label: labels?.RESEARCH ?? 'Research and Scholarship',
            colourTheme: colors.blue,
            amount: researchTarget,
            target: researchTarget,
        },
        {
            label: labels?.ENGAGEMENT ?? 'Service and Engagement',
            colourTheme: colors.green,
            amount: serviceTarget,
            target: serviceTarget,
        },
    ];

    const seniorBarChartData = [
        {
            label: labels?.SENIOR ?? 'Senior Staff',
            colourTheme: colors.orange,
            amount: seniorTarget,
            target: seniorTarget,
        },
    ];

    const professionalBarChartData = [
        {
            label: labels?.PROFESSIONAL ?? 'Professional',
            colourTheme: colors.pink,
            amount: professionalTarget,
            target: professionalTarget,
        },
    ];

    const barChartData: BarChartData[] = [];

    if (
        workplanVersion.teachingWorkloadPortion +
            workplanVersion.researchWorkloadPortion +
            workplanVersion.serviceWorkloadPortion >
        0
    )
        barChartData.push(...academicBarChartData);

    if (workplanVersion.seniorStaffWorkloadPortion > 0) barChartData.push(...seniorBarChartData);
    if (workplanVersion.professionalStaffWorkloadPortion > 0) barChartData.push(...professionalBarChartData);
    return barChartData;
};

export default getWorkloadChartData;
